export default __webpack_public_path__ + "static/mountain2-995534ffcee1e23e275b17159bc26b17.png";